export default __webpack_public_path__ + "static/media/sr.0b9c52cc.svg";